import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Non-dismissible diagonal SAMPLE wallpaper for unpaid tenants.
 * pointer-events: none so the site stays usable; no close control.
 */
export function SampleWallpaper() {
    const tiles = Array.from({ length: 72 }, (_, i) => (_jsx("span", { style: tileStyle, children: "SAMPLE" }, i)));
    return (_jsx("div", { className: "lumora-sample-wallpaper", "aria-hidden": "true", "data-testid": "sample-wallpaper", style: rootStyle, children: _jsx("div", { style: gridStyle, children: tiles }) }));
}
const rootStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 2147483000,
    pointerEvents: "none",
    overflow: "hidden",
    userSelect: "none",
    WebkitUserSelect: "none",
};
const gridStyle = {
    position: "absolute",
    inset: "-25%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignContent: "space-around",
    gap: "2.5rem 3.5rem",
    transform: "rotate(-28deg)",
    opacity: 0.12,
};
const tileStyle = {
    fontFamily: "var(--font-body, system-ui, -apple-system, sans-serif)",
    fontSize: "clamp(2.25rem, 5.5vw, 4.25rem)",
    fontWeight: 800,
    letterSpacing: "0.14em",
    color: "var(--ink, #141413)",
    textShadow: "0 0 1px rgba(255, 255, 255, 0.65)",
    whiteSpace: "nowrap",
    lineHeight: 1,
};
//# sourceMappingURL=SampleWallpaper.js.map